/**
 * lib/spark.ts — sparkline path math, shared by the Rules list and Performance
 * table. Ported from the design prototype so the curve shape matches exactly.
 */

/** Build an SVG path string for a series within a w×h box. */
export function sparkPath(arr: number[] | null, w = 72, h = 22): string {
  if (!arr || arr.length < 2) return `M0 ${h / 2} L${w} ${h / 2}`;
  const mx = Math.max(...arr);
  const mn = Math.min(...arr);
  const rng = mx - mn || 1;
  return (
    'M' +
    arr
      .map((v, i) => {
        const x = (i / (arr.length - 1)) * w;
        const y = h - 3 - ((v - mn) / rng) * (h - 6);
        return `${x.toFixed(1)} ${y.toFixed(1)}`;
      })
      .join(' L')
  );
}

/**
 * Synthesize a smooth 8-point trend that lands on `rate` — a fallback for
 * sparklines when the backend returns a rate but no `trend[]` series.
 * Deterministic (no randomness) so renders are stable.
 */
export function trendArr(rate: number | null): number[] | null {
  if (rate == null) return null;
  const a: number[] = [];
  let v = Math.max(0.05, rate - 0.12);
  for (let i = 0; i < 8; i += 1) {
    v += (rate - v) * 0.35 + Math.sin(i * 1.7) * 0.012;
    a.push(Math.max(0.02, v));
  }
  a[7] = rate;
  return a;
}
